import http from '@/utils/http';
import i18n from '@/main';

export default {
    ValidarEstadoAceiteCar(data, lockScreen = false) {
        return http.post({
            url: '/estado-car/validar',
            data: data,
            lockScreen,
            lockMessage: i18n.t('mensagens.sistema.buscandoInformacoes')
        });
    }
};
